import { Component, Inject, OnInit } from '@angular/core';

import { filesActions } from '@src/store/reducers/filesReducer';
import { Store } from '@src/store';

@Component({
    selector: 'html-page',
    template: require('./html-page.component.html')
})
export class HtmlPageComponent implements OnInit {
    public htmlPage: string;

    constructor(
        @Inject('$state') private $state: any,
        private store: Store,
        @Inject('$sce') private $sce: any) {
    }

    public async ngOnInit() {
        const params = this.$state.params;
        const response = await this.store.dispatch({
            type : filesActions.GET_BUILD_REPORT_FILE,
            payload: {
                jobQId : params.id,
                labelId : params.labelId || 0,
                envId: params.envId || 0,
                schemaId : params.schemaId || 0
            }
        });
        this.htmlPage = this.$sce.trustAsHtml(response.data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/files/html-page/html-page.component.ts